import {Utils} from "../../../model/Utils";


export class BankType {
  id:                      number;
  name:                    string;
  createdDt:               Date;
  addToBankCode:           string;
  removeFromBankCode:      string;
  setBankCode:             string;
  ownerUserCode:           string;
  ownerFullName:           string;
  active:                  boolean;
  willBeUsedToCalculateStatutoryHolidays: boolean;
  totalAmountWillBeExportedInThePayroll: boolean;
  balanceCanBeNegative: boolean;
  synchronizeWithAPI = true;
  visibleByEmployee = true;

  isValid(){
    if (Utils.isNullOrUndefined(this.id)){
      return false;
    }
    return true;
  }

}
